import { defineFormKitConfig } from '@formkit/vue'
// import { createProPlugin, inputs } from '@formkit/pro'

function scrollToErrors(node) {
  if (node.props.type === 'form') {
    function scrollTo(node) {
      const el = document.getElementById(node.props.id)
      if (el) {
        el.focus()
      }
    }

    function scrollToErrors() {
      console.log('scrollToErrors triggered')

      node.walk((child) => {
        if (child.ledger.value('blocking') || child.ledger.value('errors')) {
          scrollTo(child)
          return false
        }
      }, true)
    }

    const onSubmitInvalid = node.props.onSubmitInvalid
    node.props.onSubmitInvalid = () => {
      if (onSubmitInvalid) {
        onSubmitInvalid(node)
      }
      scrollToErrors()
    }
    node.on('unsettled:errors', scrollToErrors)
  }
  return false
}

const postcode: FormKitValidationRule = (node: unknown, country: string) => {
  const value = node.value
  if (value === null || value === undefined || value === '') return true
  if (typeof value !== 'string') return false

  const input = value.trim()

  if (country === 'NL') {
    return /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/.test(input)
  }
  if (country === 'BE') {
    return /^[1-9][0-9]{3}$/.test(input)
  }
  return true
}

export default defineFormKitConfig(() => {
  // here we can access `useRuntimeConfig` because
  // our function will be called by Nuxt.

  // const config = useRuntimeConfig()

  // and we can use the variables to import secrets.
  //
  // ⚠️ this is just an example — if you want to use FormKit Pro
  // you will need to install the @formkit/pro dependency.
  // const pro = createProPlugin(config.FORMKIT_PRO_KEY, inputs)

  return {
    // inputs: {}, // set in src/nuxt3-base/modules/layer-formkit/index.ts: this will override the auto configuration
    // locales: {}, // set in src/nuxt3-base/modules/layer-formkit/index.ts: this will override the auto configuration
    // locale: 'nl', // set in src/nuxt3-base/modules/layer-formkit/index.ts: this will override the auto configuration
    plugins: [
      // pro
      scrollToErrors,
    ],
    // rules: {}\
    rules: {
      postcode,
    },
    messages: {
      en: {
        validation: {
          required({ name }) {
            return `Please fill out the ${name} field.`
          },
          postcode({ args }) {
            if (Array.isArray(args)) {
              const country = (args?.[0] || '')
              if (country === 'NL')
                return `Enter a valid Dutch postcode (e.g. 1234 AB).`
              if (country === 'BE')
                return `Enter a valid Belgian postcode (4 digits, e.g. 1000).`
            }
            return `Enter a valid postcode.`
          },
        },
      },
      nl: {
        validation: {
          required({ name }) {
            return `Vul het veld ${name} in.`
          },
          postcode({ args }) {
            if (Array.isArray(args)) {
              const country = (args?.[0] || '')
              if (country === 'NL')
                return `Voer een geldige Nederlandse postcode in (bijvoorbeeld 1234 AB).`
              if (country === 'BE')
                return `Voer een geldige Belgische postcode in (4 cijfers, bijvoorbeeld 1000).`
            }
            return `Voer een geldige postcode in.`
          },
        },
      },
    },
  }
})
